import { Outlet } from "react-router";
import GoogleAnalyticsPageViewTracker from "src/components/shared/GoogleAnalyticsPageViewTracker/GoogleAnalyticsPageViewTracker";
import MainLayout from "src/layouts/MainLayout";

import CookieConsentManager from "@components/CookieConsent/CookieConsentManager/CookieConsentManager";

export default function RootLayout() {
  return (
    <>
      <CookieConsentManager />
      <GoogleAnalyticsPageViewTracker />
      <MainLayout>
        <Outlet />
      </MainLayout>
    </>
  );
}
